import DocumentService from '@/service/document'
export default {
  getListDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.getListDocument(payload.page, payload.per_page, payload.status, payload.search, payload.sort, payload.group_id).then(res => {
        commit('getListDocument', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.createDocument(payload.document).then(res => {
        commit('createDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  approvalDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.approvalDocument(payload.document).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  rejectDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.rejectDocument(payload.document).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.destroyDocument(payload.document).then(res => {
        commit('destroyDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.showDocument(payload.document).then(res => {
        console.log(res.data.data.exp_date)
        commit('getDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.updateDocument(payload.document).then(res => {
        commit('updateDocument', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getVersionDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.getVersionDocument(payload.document).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyVersionDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.destroyVersionDocument(payload.document, payload.version).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createVersionDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.createVersionDocument(payload.document, payload.version).then(res => {
        commit('createVersionDoc', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  openEdit ({commit}, payload) {
    commit('openEdit')
  },
  closeEdit ({commit}, payload) {
    commit('closeEdit')
  },
  openCreateChildren ({commit}, payload) {
    commit('openCreateChildren')
  },
  closeCreateChildren ({commit}, payload) {
    commit('closeCreateChildren')
  },
  openView ({commit}, payload) {
    commit('openView')
  },
  closeView ({commit}, payload) {
    commit('closeView')
  },
  openDocument ({commit}, payload) {
    commit('openDocument')
  },
  closeDocument ({commit}, payload) {
    commit('closeDocument')
  },
  multiDestroyDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.multiDestroyDocument(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  multiApprovalDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.multiApprovalDocument(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  multiRejectDocument ({commit}, payload) {
    return new Promise((resolve, reject) => {
      DocumentService.multiRejectDocument(payload.ids).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/document/actions.js